import { Box, Button, Dialog } from '@veracity/vui'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'

import { InputFormControl } from '@/components'
import { CloneScenarioRequest } from '@/interfaces'

interface Props {
  baseScenarioName?: string
  isCloneInProgress: boolean
  onCloneScenario: (val: CloneScenarioRequest) => void
  validateNameDuplication: (val: string) => boolean | string
}

export const ProjectDetailsScenarioCardCloneDialog = ({
  baseScenarioName,
  isCloneInProgress,
  onCloneScenario,
  validateNameDuplication
}: Props) => {
  const [isVisible, setIsVisible] = useState(false)
  const { control, reset, handleSubmit } = useForm({
    defaultValues: { name: '' }
  })

  useEffect(
    () =>
      reset({ name: baseScenarioName ? `${baseScenarioName} - Clone` : '' }),
    [reset, baseScenarioName]
  )

  const handleSubmitClick = (val: any) => onCloneScenario({ name: val.name })

  const handleClose = () => {
    setIsVisible(false)
    reset()
  }

  return (
    <>
      <Button
        icon="falCopy"
        variant="tertiaryDark"
        onClick={() => setIsVisible(true)}
      />

      <Dialog
        isOpen={isVisible}
        title="Clone Scenario"
        size="lg"
        onClose={handleClose}
        cancelButton={{ text: 'Cancel', disabled: isCloneInProgress }}
        submitButton={{
          text: 'Clone',
          onClick: handleSubmit(handleSubmitClick),
          isLoading: isCloneInProgress,
          disabled: isCloneInProgress
        }}
        body={
          <Box column p={2}>
            <InputFormControl
              control={control}
              formControlName="name"
              label="Name"
              disabled={isCloneInProgress}
              rules={{ required: true, validate: validateNameDuplication }}
            />
          </Box>
        }
      />
    </>
  )
}
